//
//
//
//
//
//
//
import MdmStripe from '~/components/atoms/Global/MdmStripe.vue';
export default {
  name: 'FreeDeliveryDecoration',
  components: {
    MdmStripe
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    size: {
      type: MdmStripe.props.size.type,
      default: MdmStripe.props.size.default,
      validator: MdmStripe.props.size.validator
    }
  }
};